import { useLocalization } from "@fluent/react";
import { useGetAutoLoanProductsQuery } from "@lending/hooks/queries/AutoLoanProduct/useGetAutoLoanProductsQuery";
import { SelectedProductTag } from "./SelectedProductTag";
import { useStore } from "../../contexts/StoreContext";

export function AutoLoanSelectedProductTag() {
  const { l10n } = useLocalization();
  const { data } = useStore();
  const { autoLoanProductsData } = useGetAutoLoanProductsQuery();

  if (!autoLoanProductsData) {
    return null;
  }

  const selectedProduct = autoLoanProductsData.results.find(
    (product) => product.uuid === data.selectedProduct
  );

  const productName =
    selectedProduct?.name ?? l10n.getString("product-selection-auto-loan-name", null, "Auto loan");

  return <SelectedProductTag productName={productName} iconClass="narmi-icon-car-outline" />;
}
